import React from "react";
import DataGrid from "features/shared/components/dataGrid/DataGrid";
import { DataGridId } from "features/shared/components/dataGrid/DataGridId";
import { Customer_Deposit } from "data/endpoints";
import DepositCard from "../components/DepositCard";
import DepositHeader from "../components/DepositHeader";
import DataGridHeader from "features/shared/components/dataGrid/DataGridHeader";

const DepositsSection = () => {
  return (
    <DataGrid
      gridId={DataGridId.depositGrid}
      url={Customer_Deposit}
      filterJson={"[]"}
      renderCustomGridHeader={(count, filterActive) => (
        <DataGridHeader
          count={count}
          filterActive={!!filterActive}
        />
      )}
      renderItem={(item) => (<DepositCard deposit={item} showInvoiceTimePeriod />)}
      renderHeader={() => <DepositHeader />}
    />
  );
};

export default DepositsSection;
